// For JSLINT
/*global global: true*/

window.global = window.global || {};

global.tools = (function() {
    "use strict";

    /**
     * @deprecated Use native event.stopPropagation instead.
     *
     * @param {Object} e An event object
     */
    function cancelBubbling(e) {
        o_global.debug.warn("global.tools.cancelBubbling is deprecated, use native event.stopPropagation instead");

        e.stopPropagation();
    }

    return {
        "cancelBubbling": cancelBubbling
    };
}());
